import type { TextProps } from '@/components/Text';

import type { TypographyScales } from './Typography';

type ScaleProps = Pick<
  TextProps,
  'fontSize' | 'lineHeight' | 'textTransform' | 'fontWeight' | 'fontFamily'
>;

export const switchScaleSettings = (
  scale?: TypographyScales,
): ScaleProps | undefined => {
  switch (scale) {
    case 'button':
      return {
        fontSize: 'button',
        lineHeight: 'button',
        fontWeight: 'regular',
        fontFamily: 'openSans',
      };
    case 'h6':
      return {
        fontSize: 'h6',
        lineHeight: 'h5',
        fontWeight: 'regular',
        fontFamily: 'italianPlate',
      };
    case 'h5':
      return {
        fontSize: 'h5',
        lineHeight: 'h5',
        fontWeight: 'regular',
        fontFamily: 'italianPlate',
      };
    case 'h4':
      return {
        fontSize: 'h4',
        lineHeight: 'h4',
        fontWeight: 'regular',
        fontFamily: 'italianPlate',
      };
    case 'h4Mobile':
      return {
        fontSize: 'h4',
        lineHeight: 'h4',
        fontWeight: 'bold',
        fontFamily: 'italianPlate',
      };
    case 'h3':
      return {
        fontSize: 'h3',
        lineHeight: 'h3',
        fontWeight: 'bold',
        fontFamily: 'italianPlate',
      };
    case 'h2':
      return {
        fontSize: 'h2',
        lineHeight: 'h2',
        fontWeight: 'bold',
        fontFamily: 'italianPlate',
      };
    case 'h1':
      return {
        fontSize: 'h1',
        lineHeight: 'h1',
        fontWeight: 'bold',
        fontFamily: 'italianPlate',
      };
    case 'p1':
      return {
        fontSize: 'p1',
        lineHeight: 'p1',
        fontFamily: 'openSans',
      };
    case 'p0':
      return {
        fontSize: 'p0',
        lineHeight: 'p0',
        fontFamily: 'italianPlate',
      };
    case 'p2':
      return {
        fontSize: 'p2',
        lineHeight: 'p2',
        fontFamily: 'openSans',
      };
    case 'p3':
      return {
        fontSize: 'p3',
        lineHeight: 'p3',
        fontFamily: 'openSans',
      };
    default:
      return undefined;
  }
};
